<template>
  <review-dashboard :experiments-url="experimentsUrl"
                    :fields="fields"
                    :is-cryoem-dashboard="true"
                    :modal-fields="modalFields"
                    :modal-details-fields="modalDetailsFields"
                    :report-fields="reportFields"
                    :shifts-config="shiftsConfig"/>
</template>

<script>
  import ReviewDashboard from '@/components/evaluation/review/ReviewDashboard';
  import { ordinalNumber } from '@/helpers/commonTableColumns';

  export default {
    name: 'CryoemReviewDashboard',
    components: { ReviewDashboard },
    data() {
      return {
        fields: [
          ordinalNumber,
          {
            key: 'proposal.document_specification.document_id',
            label: 'ID',
            sortable: true,
            class: 'custom-column-id-width',
          },
          {
            key: 'proposal.title',
            label: 'Title',
            sortable: true,
            tdClass: 'custom-break-col-lg',
          },
          {
            key: 'proposal.author',
            label: 'Proposal author',
            sortable: true,
            thStyle: { width: '8%' },
            class: 'custom-break-col-md',
          },
          {
            key: 'proposal.review.review_author',
            label: 'Review author',
            sortable: true,
            thStyle: { width: '7%' },
            tdClass: 'custom-break-col-md',
          },
          {
            key: 'proposal.review.grade',
            label: 'Grade',
            tdClass: 'text-center',
            sortable: true,
          },
          {
            key: 'proposal.review.suggested_number_of_shifts',
            label: 'Shifts',
            tdClass: 'text-center',
            sortable: true,
          },
          {
            key: 'proposal.review.comments',
            label: 'Comments',
            sortable: true,
            thStyle: { width: '30%' },
          },
          {
            key: 'proposal.review.states.name',
            label: 'Status',
            sortable: true,
          },
          {
            key: 'actions',
            thStyle: { minWidth: '9rem' },
          },
        ],
        modalFields: [
          {
            key: 'proposal.document_specification.document_id',
            label: 'ID',
            sortable: true,
          },
          {
            key: 'proposal.general.discipline',
            label: 'Discipline',
            sortable: true,
          },
          {
            key: 'proposal.general.shifts',
            label: 'Requested shifts',
            sortable: true,
            tdClass: 'text-center',
          },
          { key: 'actions' },
        ],
        modalDetailsFields: [
          {
            key: 'proposal.author',
            label: 'Main proposer:',
            class: 'custom-break-col-md stacked-table-left-align',
          },
          {
            key: 'proposal.title',
            label: 'Title:',
            sortable: true,
            class: 'custom-break-col-md stacked-table-left-align',
          },
        ],
        shiftsConfig: [
          {
            type: 'Shifts',
            min: '0',
            max: '8',
            step: 2,
            model: 'suggested_number_of_shifts',
          },
        ],
        reportFields: [
          ordinalNumber,
          {
            key: 'document_specification.document_id',
            label: 'ID',
            sortable: true,
            class: 'custom-column-id-width',
          },
          {
            key: 'title',
            label: 'Title',
            class: 'custom-break-col-lg',
          },
          {
            key: 'author',
            label: 'Author',
            sortable: true,
            class: 'custom-break-col-md',
            thStyle: { width: '10%' },
          },
          {
            key: 'states.date',
            label: 'Proposal submission date',
            sortable: true,
          },
          {
            key: 'experiment_report.states.date',
            label: 'Report submission date',
            sortable: true,
          },
          {
            key: 'experiment_report.states.name',
            label: 'Report status',
          },
          {
            key: 'actions',
            thStyle: { minWidth: '9rem' },
          },
        ],
        experimentsUrl: '/documents/experiment-reports/cryoem',
      };
    },
  };
</script>

<style scoped>

</style>
